import { render, staticRenderFns } from "./add-update.vue?vue&type=template&id=59bbfc9f&scoped=true"
import script from "./add-update.vue?vue&type=script&lang=js"
export * from "./add-update.vue?vue&type=script&lang=js"
import style0 from "./add-update.vue?vue&type=style&index=0&id=59bbfc9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59bbfc9f",
  null
  
)

export default component.exports